import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ navigationItems = ['Home', 'Orders'] }) => {
  const navigate = useNavigate();

  const handleNavigation = (index, item) => {
    // Handle navigation based on index and item name
    if (index === 0) {
      // Always navigate to home for first item
      navigate('/');
    } else if (item.toLowerCase() === 'profile') {
      // Navigate to profile overview
      navigate('/profile');
    } else if (item.toLowerCase() === 'orders') {
      // Navigate to orders page
      navigate('/profile/orders');
    // } else if (item.toLowerCase() === 'purchases') {
    //   // Navigate to purchases page
    //   navigate('/profile/purchases');
    // } else if (item.toLowerCase() === 'subscription plan') {
      // Navigate to subscription page
      navigate('/profile/subscription');
    } else if (item.toLowerCase() === 'my address') {
      // Navigate to address page
      navigate('/profile/address');
    } else if (item.toLowerCase() === 'settings') {
      // Navigate to settings page
      navigate('/profile/settings');
    } else if (item.toLowerCase() === 'share app') {
      // Navigate to share page
      navigate('/profile/share');
    } else if (item.toLowerCase() === 'wishlist') {
      // Navigate to wishlist page
      navigate('/wishlist');
    } else if (item.toLowerCase().startsWith('#ord')) {
      // Extract order ID and navigate to order details
      const orderId = item.replace('#', '');
      navigate(`/profile/orders/${orderId}`);
    } else if (item.toLowerCase().startsWith('#pur')) {
      // Extract purchase ID and navigate to purchase details
      const purchaseId = item.replace('#', '');
      navigate(`/profile/purchases/${purchaseId}`);
    }
    // Add more navigation logic as needed for other items
  };

  return (
    <nav
      className="flex flex-col justify-center items-start px-4 py-2.5 mt-6 w-full text-base text-center whitespace-nowrap bg-white rounded-xl shadow-2xl max-w-[1140px] max-md:max-w-full"
      aria-label="Breadcrumb navigation"
    >
      <ol className="flex gap-1.5 justify-center items-center">
        {navigationItems.map((item, index) => (
          <React.Fragment key={index}>
            <li className="flex gap-2.5 items-start self-stretch my-auto">
              {index === navigationItems.length - 1 ? (
                <span className="text-zinc-500" aria-current="page">
                  {item}
                </span>
              ) : (
                <button
                  onClick={() => handleNavigation(index, item)}
                  className="text-green-500 hover:underline focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded transition-colors duration-200"
                >
                  {item}
                </button>
              )}
            </li>
            {index < navigationItems.length - 1 && (
              <li>
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/8dd36cc4300533b24e71b89aa3e0f9841027c920?placeholderIfAbsent=true&apiKey=d09e0bc02eef4ced83b05308e83d6101"
                  alt=""
                  className="object-contain shrink-0 self-stretch my-auto aspect-square w-[18px]"
                  role="presentation"
                />
              </li>
            )}
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
